import { useFpB2bProductCatalogProducts } from '@cart-services/hooks/fp-b2b/use-fp-b2b-product-catalog-products'
import { type AllProductDTO } from '@cart-services/types'
import { useDialog } from '@dni-hooks/useDialog'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { useMemo } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { useProductCatalog } from '../../../fp-b2b-shared/hooks/use-product-catalog'
import { DIALOG_PRODUCT_CART, DialogProductCart, type DialogProductCartProps } from '../../components/DialogProductCart'
import { type BrandInfo } from '../../constants'
import { useStmBrandStore } from '../../hooks'
import { filterNewProducts, isNewProduct } from '../../utils/new-product-filter'
import { BrandTitleBar } from './BrandTitleBar'
import { NewProductCard } from './NewProductCard'

interface BrandNewProductSectionProps {
  brand: BrandInfo
  basePath: string
}

export const BrandNewProductSection = (props: BrandNewProductSectionProps) => {
  const { brand, basePath } = props
  const { campaignId, projectCode, campaignCode, platform } = useProductCatalog()
  const { productCatalogDto } = useFpB2bProductCatalogProducts(campaignId, projectCode, campaignCode, platform)
  const isMobile = useResponsive('mobile')
  const history = useHistory()
  const { setBrand } = useStmBrandStore()
  const productCartDialogKey = `${DIALOG_PRODUCT_CART}_${brand.campaignCode}`
  const { openDialog } = useDialog<DialogProductCartProps>(productCartDialogKey)

  const newProducts = useMemo(() => filterNewProducts(
    productCatalogDto?.products.flatMap(category => category.all_product) ?? [],
  ), [productCatalogDto?.products])

  const handleNavigateToBrand = () => {
    setBrand(brand.campaignCode)
    history.push(`${basePath}/product-catalog`)
  }

  const handleSelectProduct = (product: AllProductDTO) => {
    openDialog({
      title: product.title,
      thumbnail: product.last_gallery_image || product.thumbnail,
      variations: product.variations.filter(variation => isNewProduct(variation.product_create_time)),
      basePath,
    })
  }

  if (newProducts.length === 0) {
    return (
      <Box>
        <BrandTitleBar brand={brand} />
        <Box backgroundColor={colors.white} p={3} py={6}>
          <Text align="center" color={colors.grey500}>暫無新品</Text>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      <BrandTitleBar brand={brand} onNavigateToBrand={handleNavigateToBrand} />
      <Box backgroundColor={colors.white} p={3}>
        <Box display="grid" gridTemplateColumns={isMobile ? '1fr' : 'repeat(3, 1fr)'} gap={isMobile ? 3 : 2}>
          {newProducts.map(product => (
            <NewProductCard
              key={product.id}
              product={product}
              onSelectProduct={handleSelectProduct}
            />
          ))}
        </Box>
      </Box>
      <DialogProductCart dialogKey={productCartDialogKey} />
    </Box>
  )
}
